"use client";

import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
export default function CoverageMap() {
  return <section id="coveragemap" data-nav="light" className="bg-background text-foreground py-8 md:py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative overflow-hidden rounded-xl border border-border bg-card shadow-sm aspect-[4/3] sm:aspect-[16/10] md:aspect-[16/9] max-h-[580px] w-full">
          {/* Base Coverage Map Image */}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1793066/img/ChatGPT-Image-Sep-22-2026-04_32_18-PM.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1793066/img/ChatGPT-Image-Sep-22-2026-04_32_18-PM.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1793066/img/ChatGPT-Image-Sep-22-2026-04_32_18-PM.png-wvc-sizes" alt="BMF Scaffolding coverage map showing operating areas across Southern and South East England." loading="lazy" decoding="async" className="w-full h-full object-cover object-center" />

          {/* Subtle Map Ambient Gradient to ensure badge & bottom card legibility */}
          <div className="absolute inset-0 bg-gradient-to-t from-foreground/40 via-transparent to-foreground/20 pointer-events-none" aria-hidden="true" />

          {/* Top Overlays */}
          <div className="absolute top-3 left-3 sm:top-5 sm:left-5 right-3 sm:right-5 flex flex-wrap items-center justify-between gap-2.5 z-10 pointer-events-none">
            <Badge variant="secondary" className="pointer-events-auto bg-card/90 backdrop-blur-xs text-card-foreground border border-border/80 shadow-xs px-3 py-1.5 text-xs font-medium gap-2">
              <span className="relative flex size-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75" />
                <span className="relative inline-flex rounded-full size-2 bg-primary" />
              </span>
              <span>Active Operations Zone: South East</span>
            </Badge>

            <Badge variant="outline" className="pointer-events-auto bg-card/90 backdrop-blur-xs text-card-foreground border border-border/80 shadow-xs px-2.5 py-1.5 text-xs font-medium gap-1.5">
              <ShieldCheck className="size-3.5 text-primary" />
              <span>NASC Registered</span>
            </Badge>
          </div>

          {/* Bottom Floating Card */}
          <div className="absolute bottom-3 left-3 right-3 sm:bottom-5 sm:left-5 sm:right-5 z-10">
            <motion.div whileHover={{
            y: -2
          }} transition={{
            duration: 0.2,
            ease: "easeOut"
          }} className="bg-card/95 backdrop-blur-md border border-border rounded-lg p-4 sm:p-5 shadow-md flex flex-col md:flex-row md:items-center justify-between gap-4">
              <div className="space-y-1 max-w-2xl">
                <p className="text-xs sm:text-sm font-semibold tracking-wide text-foreground uppercase">
                  BMF Scaffolding Ltd • South East Operations
                </p>
                <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                  Providing commercial, residential and specialist scaffolding services across Berkshire, Surrey, Hampshire, Buckinghamshire, Greater London and the wider South East.
                </p>
              </div>

              <div className="shrink-0">
                <Button asChild variant="default" size="sm" className="w-full sm:w-auto shadow-xs font-medium text-xs sm:text-sm">
                  <Link to="/AreasWeCoverPage">
                    View areas
                    <ArrowRight className="size-3.5 ml-1" />
                  </Link>
                </Button>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}